@if ($context(); as ctx) {
  @if (ctx.settingsPanel; as settingsPanel) {
    <div class="command-palette-backdrop" (click)="onBackdropClick()"></div>
    <div class="command-palette-card">
      @if (ctx.scopeChip) {
        <div class="command-palette-scope-row">
          <w-badge class="command-palette-scope" [label]="ctx.scopeChip.label" iconRight="fa-regular fa-delete-left" size="xs" />
        </div>
      }
      <wb-settings-panel
        class="command-palette-page"
        [panel]="settingsPanel"
        [mode]="SettingsPanelMode.CommandPalette"
        [dismissOnClickOutside]="false"
        (closed)="onSettingsPanelClosed()" />
    </div>
  }
}
